import { combineReducers } from "redux";
import heightReducer from "./reducers/heightReducer";
import demoReducer from "./reducers/demoReducer";
import nutritionReducer from "./reducers/nutritionReducer";

const rootReducer = combineReducers({
  heightReducer,
  demoReducer,
  nutritionReducer,
});

export default rootReducer;
